import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const ConsumerGoods = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / FMCG</h6>
          <hr />
          <h1 className="banner-title">
            Driving Growth in the FMCG <br />
            Sector with Innovative Software Solutions
          </h1>

          <p>
            Empowering consumer goods companies to streamline operations, <br />{" "}
            optimize supply chains, and enhance customer engagement through
            cutting-edge technology.
          </p>

          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/woman-checking-her-delivery-groceries_23-2149950088.jpg"
          alt="Consumer Goods Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6 className="col_yell text-center">
                Fast-Moving Consumer Goods (FMCG)
              </h6>
              <h2 className="text-center">
                Streamlining Operations and Enhancing Customer Engagement in the
                Consumer Goods Sector
              </h2>
              <p className="text-center">
                The consumer goods industry faces numerous challenges, from
                managing complex supply chains to understanding customer
                preferences. Our software solutions empower businesses in this
                sector to enhance operational efficiency, improve
                decision-making, and drive sustainable growth.
              </p>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <div className="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Our Solutions</h2>
              <p className="text-center mb-0">
                Our software solutions cater specifically to the needs of the
                consumer goods industry, helping businesses improve supply chain
                management, boost marketing efforts, and enhance customer
                satisfaction.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Supply Chain Management</a>
              </h3>
              <p className="mb-4">
                Our supply chain management software enables consumer goods
                companies to optimize inventory, reduce stockouts, and
                streamline logistics, improving overall supply chain efficiency
                and lowering costs.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Customer Relationship Management (CRM)</a>
              </h3>
              <p className="mb-4">
                Enhance customer satisfaction and loyalty with our CRM systems
                that provide insights into customer preferences, enabling
                personalized marketing, targeted sales efforts, and improved
                customer service.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Product Lifecycle Management</a>
              </h3>
              <p className="mb-4">
                Manage your product lifecycle efficiently from ideation to
                market launch and beyond, ensuring timely delivery, quality
                control, and effective coordination between departments and
                suppliers.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Retail Management Systems</a>
              </h3>
              <p className="mb-4">
                Our retail management solutions help businesses optimize store
                operations, manage inventory in real time, track sales
                performance, and enhance the overall shopping experience for
                consumers.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Data Analytics and Insights</a>
              </h3>
              <p className="mb-4">
                Leverage big data to analyze consumer behavior, market trends,
                and product performance, enabling data-driven decision-making
                and helping businesses stay ahead of the competition.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">E-Commerce Solutions</a>
              </h3>
              <p className="mb-4">
                Build and manage an efficient e-commerce platform with our
                tailored solutions, including online payment systems, order
                management, and customer support tools, to reach a larger
                audience and increase sales.
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2 className="">
                  Ready to Accelerate Your Consumer Goods Business?
                </h2>
                <p className="mt-3">
                  Our innovative software solutions help businesses in the
                  consumer goods sector streamline operations, improve customer
                  engagement, and unlock new growth opportunities. Let’s work
                  together to drive success.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/group-friends-shopping-mall-having-fun_1150-9282.jpg"
                        className="w-100"
                        alt="Consumer Goods Solutions"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConsumerGoods;
